<div class="drawer-header">
  <h5 class="details-text">Contact info</h5>
  <button
    mat-icon-button
    color="primary"
    aria-label="Example icon button with a home icon"
    (click)="toggleSidebarOpen('firmDirectoryContactDetail')"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
@if ($UserDetail | async; as userDetail) {
  <div class="drawer-body">
    <div class="box-topblock">
      <div class="box-imageblock">
        <img
          class="box-image"
          [src]="userDetail?.PHOTO !== '' ? userDetail.PHOTO : 'assets/images/profile/user.png'"
        />
      </div>
      <div class="card-maintitle">{{ userDetail?.FULLNAME }}</div>
      <div class="card-subtext">{{ userDetail?.POSITION }}</div>
    </div>
    @if (userflag) {
      <div class="drawer-detailsblock">
        <h5 class="details-text">Details</h5>
        @if (userDetail) {
          <ul class="details-listwrap">
            @if (userDetail?.EMAIL) {
              <li>
                <span>Email</span>
                {{ userDetail?.EMAIL }}
              </li>
            }
            @if (userDetail?.PHONE1) {
              <li>
                <span>Phone number</span>
                {{ userDetail?.PHONE1 }}
              </li>
            }
            @if (userDetail?.OFFICELOCATION) {
              <li>
                <span>Address</span>
                {{ userDetail?.OFFICELOCATION }}
              </li>
            }
            @if (userDetail?.BIOGRAPHY) {
              <li>
                <span>Biography</span>
                @if (userDetail?.BIOGRAPHY) {
                  <div
                    class="biography_detail"
                    [innerHTML]="$safeNavigationMigration(userDetail?.BIOGRAPHY)"
                  ></div>
                }
              </li>
            }
          </ul>
        }
      </div>
    }
    @if (!userflag) {
      <div class="drawer-detailsblock">This user details not available.</div>
    }
  </div>
}
